import type { Glyph } from "./types";

export const MinusIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M45.116 24.1C45.613 24.1 46.015 24.503 46.015 25C46.015 25.497 45.613 25.901 45.116 25.901L4.885 25.901C4.388 25.901 3.985 25.497 3.985 25C3.985 24.503 4.388 24.1 4.885 24.1L45.116 24.1Z" />
  </svg>
);

export default MinusIcon;
